import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useLocation, useHistory, Redirect } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'

import { useBoot } from 'Core/Hooks/useBoot'
import Notifier from 'Utils/Notifier'
import { LayoutProvider } from 'features/layout'
import AdminRoutes from './admin'
import UserRoutes from './user'
import { NotFound } from 'features/layout'

function Routes() {
  const { bootComplete } = useBoot()
  const user = useSelector((state) => state.user)
  const isAuthenticated = user?.loggedIn

  const location = useLocation()
  const history = useHistory()

  // Capture entry path ONCE — never updated after mount
  const initialPathRef = useRef(location.pathname)
  const redirectedRef = useRef(false)

  useEffect(() => {
    if (!bootComplete || !isAuthenticated || redirectedRef.current) return

    if (
      initialPathRef.current === '/' ||
      initialPathRef.current === '/index.html' ||
      initialPathRef.current === '/user/'
    ) {
      redirectedRef.current = true
      history.replace(user.role === 'admin' ? '/admin/dashboard' : '/user/targets')
    }
  }, [bootComplete, isAuthenticated, history, user.role])

  return (
    <SnackbarProvider maxSnack={1}>
      <Notifier />

      <Switch>
        {isAuthenticated && (
          <Route path='/*'>
            <LayoutProvider>
              {bootComplete && (
                <Switch>
                  {/* ADMIN */}
                  <Route path='/admin'>
                    {user?.role === 'admin' ? <AdminRoutes /> : <Redirect to='/user' />}
                  </Route>

                  {/* USER */}
                  <Route path='/user'>
                    <UserRoutes />
                  </Route>

                  {/* FALLBACK */}
                  <Route>
                    <NotFound />
                  </Route>
                </Switch>
              )}
            </LayoutProvider>
          </Route>
        )}
      </Switch>
    </SnackbarProvider>
  )
}

export { Routes }
